import { CheckNotes, InspectionCase, SummaryNotes } from '../inspection-cases';
import { Cases, Inspection } from '../inspection.dto';
import { PlanningDetails } from '../planning-details.dto';
import { FireAlarmSystemDesign } from './fire-alarm-system-design.dto';

export class InspectionFireAlarmSystemDto extends InspectionCase {
  fireAlarmSystemDesign?: FireAlarmSystemDesign;
  planningDetails?: PlanningDetails;
  summaryNotes?: SummaryNotes[];
}

export class InspectionFireAlarmSystem
  extends InspectionFireAlarmSystemDto
  implements Inspection
{
  constructor(
    data: InspectionFireAlarmSystemDto = {
      title: 'בדיקת התקנת מערכת גילוי אש',
      isApplicable: true,
      summaryNotes: [
        {
          addNotesToReport: true,
          notes: `כל שינוי במערכת מחייב בדיקת התקנה נוספת`
        },
        {
          addNotesToReport: true,
          notes: `כל שינוי במספר הטלפון של החייגן, יש לעדכן את מס' הטלפון המתוכנת ולבדוק את פעולת החייגן`
        },
        {
          addNotesToReport: true,
          notes: `תעודה זו מתייחסת לממצאים כפי שהתקבלו במעמד הבדיקה`
        }
      ]
    }
  ) {
    super(data);
    this.summaryNotes = data.summaryNotes;
    this.planningDetails = new PlanningDetails(data.planningDetails);
    this.fireAlarmSystemDesign = new FireAlarmSystemDesign(
      data.fireAlarmSystemDesign
    );
  }

  setInspectionStatus(): void {
    this.fireAlarmSystemDesign.setInspectionStatus();

    this.isPassed = this.fireAlarmSystemDesign.isPassed;
  }

  getNotes?(): CheckNotes[] {
    if (!this.isApplicable) {
      return [];
    }
    return [...this.fireAlarmSystemDesign.getNotes()];
  }

  setAsApplicable?(): void {
    this.isApplicable = true;
    this.fireAlarmSystemDesign.setAsApplicable();
  }

  getCases(): Cases[] {
    return [
      {
        title: this.fireAlarmSystemDesign.title,
        cases: [
          this.fireAlarmSystemDesign.main,
          this.fireAlarmSystemDesign.fireAlarmSystemComponents,
          this.fireAlarmSystemDesign.dialRiskLevelOne,
          this.fireAlarmSystemDesign.dialRiskLevelTwo,
          this.fireAlarmSystemDesign.dialRiskLevelTwoAccommodation,
          this.fireAlarmSystemDesign.autoDialer,
          this.fireAlarmSystemDesign.cellularAutoDialer,
          this.fireAlarmSystemDesign.discoveryHub,
          this.fireAlarmSystemDesign.detectorsInstallation,
          this.fireAlarmSystemDesign.beamsAndPartitions,
          this.fireAlarmSystemDesign.powerPanel,
          this.fireAlarmSystemDesign.sirensAndMarkingLamps,
          this.fireAlarmSystemDesign.paSystem,
          this.fireAlarmSystemDesign.specialInstallations,
          this.fireAlarmSystemDesign.firefightersPhone,
          this.fireAlarmSystemDesign.componentsActivation,
          this.fireAlarmSystemDesign.standaloneDetectors
        ]
      }
    ];
  }
}
